/* tslint:disable */
/* eslint-disable */
/**
 * Atelier Roles API
 * L\'Atelier des rôles (BO admin) : référentiel des briques (standard verrouillées, personnalisées administrables), profils (ensembles de rôles appliqués à la création des acteurs) et matrice rôles/portails. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BriqueReferentielDto } from './BriqueReferentielDto';
import {
    BriqueReferentielDtoFromJSON,
    BriqueReferentielDtoFromJSONTyped,
    BriqueReferentielDtoToJSON,
    BriqueReferentielDtoToJSONTyped,
} from './BriqueReferentielDto';

/**
 * 
 * @export
 * @interface GetReferentielBriquesResponse
 */
export interface GetReferentielBriquesResponse {
    /**
     * 
     * @type {Array<BriqueReferentielDto>}
     * @memberof GetReferentielBriquesResponse
     */
    briques: Array<BriqueReferentielDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetReferentielBriquesResponse
     */
    portails: Array<string>;
}

/**
 * Check if a given object implements the GetReferentielBriquesResponse interface.
 */
export function instanceOfGetReferentielBriquesResponse(value: object): value is GetReferentielBriquesResponse {
    if (!('briques' in value) || value['briques'] === undefined) return false;
    if (!('portails' in value) || value['portails'] === undefined) return false;
    return true;
}

export function GetReferentielBriquesResponseFromJSON(json: any): GetReferentielBriquesResponse {
    return GetReferentielBriquesResponseFromJSONTyped(json, false);
}

export function GetReferentielBriquesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReferentielBriquesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'briques': ((json['briques'] as Array<any>).map(BriqueReferentielDtoFromJSON)),
        'portails': json['portails'],
    };
}

export function GetReferentielBriquesResponseToJSON(json: any): GetReferentielBriquesResponse {
    return GetReferentielBriquesResponseToJSONTyped(json, false);
}

export function GetReferentielBriquesResponseToJSONTyped(value?: GetReferentielBriquesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'briques': ((value['briques'] as Array<any>).map(BriqueReferentielDtoToJSON)),
        'portails': value['portails'],
    };
}

